import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
 IFramePaymentResponse, PaymentMethodTypeEnumConvertor,
    IFrameSavePaymentMethodResponse,
    PaymentMethodData,
} from 'apps/public-portal/src/app/payment-integrations/base/models';
import { PaymentProcessorService } from 'apps/public-portal/src/app/payment-integrations/base/interfaces';
import {
    IFramePaymentRequestDto,
    IFrameSavePaymentMethodRequestDto,
    IFrameSavePaymentMethodResponseDto,
    SharedPaymentIntegrationApiClient
} from 'apps/public-portal/src/app/core/api/PaymentIntegrationApiClients';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MSBService extends PaymentProcessorService {
    // these are loaded in the assignAdditionalProps
    // method in the base class PaymentProcessorService
    public vgsEnvironment: string;

    public vgsVaultId: string;

    public vgsVersion: string;

    constructor(
        private router: Router,
        public sharedPaymentApi: SharedPaymentIntegrationApiClient
    ) {
        super(sharedPaymentApi);
    }

    public override checkout() {
        this.router.navigate(['/checkout']);
    }

    public override async payCart(params): Promise<IFramePaymentResponse> {
        const request = new IFramePaymentRequestDto();
        const { paymentMethodData }: { paymentMethodData: PaymentMethodData } = params;
        if (params.authorizationConsent) request.authorizationConsent = params.authorizationConsent;
        if (params.savedPaymentMethodAuthorizationConsent) request.savedPaymentMethodAuthorizationConsent = params.savedPaymentMethodAuthorizationConsent;

        request.cartId = params.cartId;
        request.cartGuid = params.cartGuid;
        request.paymentMethodType = PaymentMethodTypeEnumConvertor.toDto(
            params.paymentMethodType ?? paymentMethodData.type
        );
        request.inboundRedirectSourceId = params.inboundRedirectSourceId;
        request.validationToken = params.validationToken;

        if (!params.saved) {
            this.mapRequest(request, paymentMethodData, params.paymentToken);
        }

        const response = await firstValueFrom(this.sharedPaymentApi.makePayment(request));

        return new IFramePaymentResponse({
            emailAddress: response.emailAddress,
            errorMessage: response.responseMessage,
            cartStatus: response.responseSuccess,
            processorTrackingId: response.processorTrackingId,
        });
    }

    public override async savePaymentMethod(params): Promise<IFrameSavePaymentMethodResponse> {
        const request = new IFrameSavePaymentMethodRequestDto();
        const { paymentMethodData }: { paymentMethodData: PaymentMethodData } = params;
        if (params.authorizationConsent) request.authorizationConsent = params.authorizationConsent;

        this.mapRequest(request, paymentMethodData, params.paymentToken);
        let response: IFrameSavePaymentMethodResponseDto;
        if (params.paymentMethodId) {
            response = await firstValueFrom(this.sharedPaymentApi.updatePaymentMethod(params.paymentMethodId, request));
        } else {
            response = await firstValueFrom(this.sharedPaymentApi.addPaymentMethod(request));
        }

        return new IFrameSavePaymentMethodResponse({
            paymentMethodId: response.paymentMethodId,
            last4: request.last4,
        });
    }
}
